"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isPromise(obj) {
    return (!!obj &&
        (typeof obj === 'object' || typeof obj === 'function') &&
        typeof obj.then === 'function');
}
var BiliEventEmitter = (function () {
    function BiliEventEmitter() {
        this.eventMap = {};
    }
    BiliEventEmitter.prototype.once = function (type, handler) {
        if (!type || !handler) {
            return false;
        }
        if (!this.eventMap[type]) {
            this.eventMap[type] = [];
        }
        this.eventMap[type].push({
            type: type,
            handler: handler,
            options: {
                once: true,
            },
        });
    };
    BiliEventEmitter.prototype.on = function (type, handler) {
        if (!type || !handler) {
            return false;
        }
        if (!this.eventMap[type]) {
            this.eventMap[type] = [];
        }
        this.eventMap[type].push({
            type: type,
            handler: handler,
        });
    };
    BiliEventEmitter.prototype.off = function (type, handler) {
        var collect = this.eventMap[type];
        if (!Array.isArray(collect)) {
            return false;
        }
        if (!handler) {
            delete this.eventMap[type];
        }
        var idx = collect.findIndex(function (target) { return handler === target.handler; });
        if (idx > -1) {
            collect.splice(idx, 1);
        }
    };
    BiliEventEmitter.prototype.emit = function (type, payload, callback) {
        var collect = this.eventMap[type];
        if (!Array.isArray(collect)) {
            return false;
        }
        var processor = [];
        collect.forEach(function (evt, index) {
            var feedback = evt.handler(payload);
            if (isPromise(feedback)) {
                processor.push(feedback);
            }
            if (evt.options && evt.options.once) {
                collect.splice(index, 1);
            }
        });
        Promise.all(processor)
            .then(function () {
            return callback ? callback() : null;
        })
            .catch(console.warn);
    };
    return BiliEventEmitter;
}());
exports.BiliEventEmitter = BiliEventEmitter;
if (!window.BiliActEvents) {
    window.BiliActEvents = new BiliEventEmitter();
}
exports.default = window.BiliActEvents;
